import Logging from "logging";
import { useEffect } from "react";

const usePreventZoom = () => {
  useEffect(() => {
    const addMaximumScaleToMetaViewport = () => {
      const metaElement = document.querySelector("meta[name=viewport]");

      if (!metaElement) {
        Logging.log("layout", "n/a", "meta[name=viewport] is not found");
        return;
      }

      let content = metaElement.getAttribute("content");
      const re = /maximum-scale=[0-9.]+/g;

      if (!content) {
        Logging.log("layout", "n/a", "content of meta element does not exist");
        return;
      }

      if (re.test(content)) {
        content = content.replace(re, "maximum-scale=1.0");
      } else {
        content = [content, "maximum-scale=1.0"].join(", ");
      }

      metaElement.setAttribute("content", content);
    };

    const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

    // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    const checkIsIOS = () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (checkIsIOS()) {
      disableIosTextFieldZoom();
    }
  }, []);
};

export default usePreventZoom;
